// extracted by mini-css-extract-plugin
export default {"main":"main_main__P1lma","mainBanner":"main_mainBanner__FAPmv"};